import {
  FiberNewOutlined,
  Autorenew,
  PauseCircleOutline,
  EmojiEventsOutlined,
  CancelOutlined,
  BlockOutlined,
  PhoneOutlined,
  VisibilityOutlined,
  ForumOutlined,
  AssessmentOutlined,
  AssignmentTurnedInOutlined,
  CampaignOutlined,
  LocalOfferOutlined,
  LocalFireDepartment
} from "@material-ui/icons";
import type { SvgIconProps } from "@material-ui/core";
import type { ComponentType } from "react";

// Maps stable icon keys to concrete icons. Keys come from two places:
//   - the top-level CrmStatus ids themselves (new / in_progress / paused / won / lost), and
//   - the `icon` key on each CrmSubStatusDefinition (contacted, presenting, …).
// Kept on the dashboard (not the shared schema) because the schema is also consumed server-side,
// which never renders icons.
const STATUS_ICON_BY_KEY: Record<string, ComponentType<SvgIconProps>> = {
  // top-level lifecycle statuses
  new: FiberNewOutlined,
  in_progress: Autorenew,
  paused: PauseCircleOutline,
  won: EmojiEventsOutlined,
  lost: CancelOutlined,
  irrelevant: BlockOutlined,
  // sub-statuses (under בטיפול)
  contacted: PhoneOutlined,
  presenting: VisibilityOutlined,
  negotiating: ForumOutlined,
  appraisal: AssessmentOutlined,
  listing_signed: AssignmentTurnedInOutlined,
  marketing: CampaignOutlined,
  offers: LocalOfferOutlined
};

export function CrmStatusIcon({ iconKey, ...props }: { iconKey?: string } & SvgIconProps): JSX.Element | null {
  const Icon = iconKey ? STATUS_ICON_BY_KEY[iconKey] : undefined;
  return Icon ? <Icon {...props} /> : null;
}

// The hot-lead fire: filled red when hot, muted outline when not. One source of truth for every
// surface that renders the flag (edit-modal toggle, table chip, future inline popovers).
export function CrmHotFireIcon({ isHot, sx, ...props }: { isHot: boolean } & SvgIconProps): JSX.Element {
  return <LocalFireDepartment {...props} sx={{ color: isHot ? "error.main" : "text.disabled", ...sx }} />;
}
